import { getToken } from "./apiHelper";
import api from "./api";

export const productService = {
  getDispatchProducts: async (days)  => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      };
  //daed39f3-7e0c-4084-7572-08dceb8a6965 isletme kullanıcısı id
      const response = await api.get(`/Dispatches/GetSevkBilgi?gun=${days}`,  axiosConfig);
  console.log(response)
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    } 
  }, 
  getAllDispatchProducts: async (page,pageSize,filter)  => {
    const search = filter ? `&search=${encodeURIComponent(filter)}` : "";
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Dispatches/GetSevkBilgiPaginated?page=${page}&pageSize=${pageSize}${search}&OrderByProperty=sevkTar&asc=false&Day=60&CurrentId=-1`,  axiosConfig);
      console.log(response)
      return response.data.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    } 
  },
  getAllWarehouseProducts: async (page,pageSize,filter)  => {
    const search = filter ? `&search=${encodeURIComponent(filter)}` : "";
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Dispatches/GetSevkDepoPaginated?page=${page}&pageSize=${pageSize}${search}&OrderByProperty=tarihFormatted&asc=false&Day=60&CurrentId=-1`,  axiosConfig);
      console.log(response)
      return response.data.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    } 
  },
   getCheckLists: async (page,pageSize)  => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Vouchers/getallpaginated?page=${page}&pageSize=${pageSize}&orderByProperty=Date&asc=false`,  axiosConfig);

      return response.data.data;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    } 
  },
  getDispatchProductDetails: async (belgeNo,parti,cariId )  => {
    const cari = cariId ? `&cariId=${encodeURIComponent(cariId)}` : "";
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Dispatches/GetSevkParti?belgeNo=${belgeNo}&parti=${parti}${cari}`,  axiosConfig);
      console.log(response)
      return response.data.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }  
  },

  getWarehouseProducts: async ()  => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Dispatches/GetSevkDepo`,  axiosConfig);
      console.log(response)
      return response.data;
    } catch (error) {
      console.error("error:", error);
   return [];
    }  
  }, 
  getCurrentProducts: async ()  => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/CurrentsStocks/getCurrentsStocks`,  axiosConfig);

      return response.data.data;
    } catch (error) {
      console.error("error:", error);
      return [];
    }  
  },

  
};